module.exports = __webpack_public_path__ + "img/LOGO.524fec21.jpg";